// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Localidades_HealthcheckResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /localidades/healthCheck
 *
 * Proxy to locations-service (Go microservice). The upstream returns
 * `Dados: true` from `Envia_dados_json(c, true)` on success; on failure
 * the model returns `false` and we still emit it via this contract
 * (envelope success flag is decoupled from this primitive).
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Localidades_HealthcheckResponseDados = boolean;

export type Localidades_HealthcheckResponse = ApiResponse<Localidades_HealthcheckResponseDados>;

registerResponseContract('Localidades_HealthcheckResponse', {})
